import { Flex, Skeleton, Tabs, TabList, TabPanels, TabPanel, Tab } from '@chakra-ui/react';
import { useGetReportInfo } from 'query/reporting';
import { PortfolioNetRevenue } from './PortfolioNetRevenue';
import { NetRevenueBreakdown } from './NetRevenueBreakdown';
import { PortfolioRevDistribution } from './PortfolioRevDistribution';
import { PortfolioNetPosition } from './PortfolioNetPosition';
import { MonthHourNetPosition } from './MonthHourNetPosition';
import { FormattedMessage, useIntl } from 'react-intl';

interface PortfolioEnergyAndRevenueProps {
    studyId: number;
}

export function PortfolioEnergyAndRevenue({ studyId }: PortfolioEnergyAndRevenueProps) {
    const intl = useIntl();
    const { data, isError, isFetching } = useGetReportInfo({ studyId, reportType: 'PortfolioEnergyAndRev' });

    if (isFetching) {
        return <Skeleton height="40px" width="100%" m={4} />;
    }

    if (isError || !data) {
        return <FormattedMessage id="common_generic_loading_error" />;
    }

    return (
        <Tabs h="full" w="full" isLazy={true} variant="enclosed">
            <TabList>
                <Flex px={6} w="100%">
                    <Tab flexShrink={0} key="PortfolioNetRevenue">
                        {intl.formatMessage({ id: 'reporting_portfolio_energy_revenue_portfolio_net_revenue_title' })}
                    </Tab>
                    <Tab flexShrink={0} key="ProjectNetRevenue">
                        {intl.formatMessage({ id: 'reporting_portfolio_energy_revenue_project_net_revenue_title' })}
                    </Tab>
                    <Tab flexShrink={0} key="PortfolioRevDistribution">
                        {intl.formatMessage({
                            id: 'reporting_portfolio_energy_revenue_portfolio_revenue_distribution_title',
                        })}
                    </Tab>
                    <Tab flexShrink={0} key="PortfolioNetPosition">
                        {intl.formatMessage({ id: 'reporting_portfolio_energy_revenue_portfolio_net_position_title' })}
                    </Tab>
                    <Tab flexShrink={0} key="MonthHourNetPosition">
                        {intl.formatMessage({
                            id: 'reporting_portfolio_energy_revenue_portfolio_month_hour_net_position_title',
                        })}
                    </Tab>
                </Flex>
            </TabList>
            <TabPanels>
                <TabPanel p={4} key="PortfolioNetRevenue">
                    <PortfolioNetRevenue info={data} />
                </TabPanel>
                <TabPanel p={4} key="ProjectNetRevenue">
                    <NetRevenueBreakdown info={data} />
                </TabPanel>
                <TabPanel p={4} key="PortfolioRevDistribution">
                    <PortfolioRevDistribution info={data} />
                </TabPanel>
                <TabPanel p={4} key="PortfolioNetPosition">
                    <PortfolioNetPosition info={data} />
                </TabPanel>
                <TabPanel p={4} key="MonthHourNetPosition">
                    <MonthHourNetPosition info={data} />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
}
